export default __webpack_public_path__ + "static/media/manax.22e54c2f.svg";